export const toJsonSafe = (value: unknown): unknown => {
  try {
    return JSON.parse(
      JSON.stringify(value, (_key, v) => {
        if (typeof v === "function" || typeof v === "symbol") {
          return undefined;
        }
        if (typeof v === "bigint") {
          return v.toString();
        }
        if (v instanceof Date) {
          return v.toISOString();
        }
        if (v instanceof Map || v instanceof Set) {
          return undefined;
        }
        return v;
      }),
    );
  } catch {
    return undefined;
  }
};
